import { motion } from "framer-motion";
import { EASE } from "@/lib/api";

export const Reveal = ({ children, delay = 0, y = 36, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

const line = { hidden: { y: "110%" }, show: { y: "0%", transition: { duration: 1.15, ease: EASE } } };

export const MaskLines = ({ lines, as = "h2", className = "", onLoad = false, delay = 0, stagger = 0.12, testId }) => {
  const Tag = motion[as];
  const trigger = onLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.15 } };
  return (
    <Tag
      data-testid={testId}
      className={className}
      initial="hidden"
      {...trigger}
      variants={{ show: { transition: { staggerChildren: stagger, delayChildren: delay } } }}
    >
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span className="block" variants={line}>
            {l}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};
